import { FVS_REVIEW_STATUS } from '../../../utilities/constants';

// Status tags live in utilities/fvs-status-tags so the authenticated and
// public FVS pages share one implementation.
export {
  mapStatusToTags,
  mapFvsStatusToTags,
  mapHistoryRowToTags,
} from '../../../utilities/fvs-status-tags';

/**
 * Label the aggregated peer review status shown under Status on the FVS detail
 * panel. Returns null when there is nothing to show - which includes users the
 * service withholds the field from, so the row is simply omitted for them.
 */
export const mapReviewStatusToTag = (reviewStatus) => {
  switch (reviewStatus) {
    case FVS_REVIEW_STATUS.NotApplicable:
      return { value: 'N/A', variant: 'Inactive-Gray' };
    case FVS_REVIEW_STATUS.NotStarted:
      return { value: 'Not started', variant: 'Ready-Gray' };
    case FVS_REVIEW_STATUS.InProgress:
      return { value: 'In progress', variant: 'Info-Gray' };
    case FVS_REVIEW_STATUS.Done:
      return { value: 'Done', variant: 'Inactive-Gray' };
    default:
      return null;
  }
};
